export default __webpack_public_path__ + "static/media/logo6.c7f10ff6.jpg";